// Single source of truth for the Meta Pixel / Dataset ID used across the funnel.
// The browser pixel and the server-side Conversions API both report to this ID.
export const META_PIXEL_ID = "1178316203589856";
